import React, { useState } from 'react';
import { Button, Modal, Box, Dialog, DialogContent, Stack, Container, Divider, TextField } from '@mui/material';
import apiInstance from '../../../../services/ServiceApi';
import CreateUser from './UserAdd';
import UsersGrid from './UserList';
import AddIcon from '@mui/icons-material/Add';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import DownloadIcon from '@mui/icons-material/Download';
import ToastMessagge from '../../../../components/utilities/ToastMessage';
import UploadUserForm from './UploadUser';
import PageHeader from '../../../../components/admin/PageHeader';
function UsersManager() {
    const [open, setOpen] = useState(false);
    const [openImportModal, setOpenImportModal] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMsg, setToastMsg] = useState('');
    const [updateGrid, setUpdateGrid] = useState(false);
    const [toastSeverity, setToastSeverity] = useState('success');
    const handleOpenImportModal = () => {
        setOpenImportModal(true);
    };
    
    const handleCloseImportModal = () => {
        setOpenImportModal(false);
    };
    const handleUserCreated = (userId, formData) => {
        setToastMsg({'Nuevo usuario creado con ID:': userId});
        setToastSeverity('success'); // o 'error' si hubo un error
        setToastOpen(true); // Muestra el toast
        setUpdateGrid(prev => !prev);
    };
    const handleExportUsers = () => {
        apiInstance.get('/export_user/')
            .then(response => {
            })
            .catch(error => {
                console.error("Error al exportar usuarios:", error);
            });
    };

    return (
        <>
            <PageHeader title="Listado de Usuarios"/>
            <Divider></Divider>
            <Stack direction="row" spacing={2} mb={2}>
            <Button 
                variant="contained" 
                color="primary" 
                style={{ marginRight: '10px' }}
                onClick={()=>setOpen(true)}
                startIcon={<AddIcon />} 
            >
            Agregar Usuario
            </Button>
            
            <Button 
                variant="contained" 
                style={{ marginRight: '10px' }}
                onClick={handleOpenImportModal}
                startIcon={<ImportExportIcon />}
                >
                Importar Usuarios
            </Button>

            <Button 
                variant="contained" 
                color="secondary"
                onClick={handleExportUsers}
                startIcon={<DownloadIcon />}  // Ícono para "Exportar Usuarios"
            >
                Exportar Usuarios
            </Button>
            </Stack>
            <ToastMessagge
                open={toastOpen}
                onClose={()=>   setToastOpen(false)}
                msg={toastMsg}
                severity={toastSeverity}
            />
            <Dialog open={open} onClose={()=>setOpen(false)} aria-labelledby="Agregar Usuario" fullWidth maxWidth="md">
                <DialogContent>
                    <CreateUser closeModal={()=>setOpen(false)} onUserCreated={handleUserCreated} isEditMode={false} />
                </DialogContent>
            </Dialog>
            <Dialog open={openImportModal} onClose={handleCloseImportModal} aria-labelledby="importar-usuarios" fullWidth maxWidth="md">
                <DialogContent>
                <UploadUserForm closeModal={handleCloseImportModal} />
                </DialogContent>
            </Dialog>
            <UsersGrid shouldUpdate={updateGrid}  />
        </>
    );
}

export default UsersManager;
